import React from 'react';
import SafeIcon from '../common/SafeIcon';

const updates = [
  { id: 1, date: 'Nov 12, 2024', author: 'Alex Vance', type: 'Strategic', content: 'Stage Gate 3 cleared. Marketing assets for "Project Nebula" are now 84% complete. We are on track for the Nov 26 launch window.', status: 'Sent' },
  { id: 2, date: 'Nov 10, 2024', author: 'Sarah Jenkins', type: 'Risk Alert', content: 'Server capacity testing identified a potential bottleneck for the day-1 traffic spike. Mitigating via edge-caching expansion.', status: 'Sent' },
  { id: 3, date: 'Nov 05, 2024', author: 'System Bot', type: 'Automated', content: 'Weekly readiness report generated. Overall progress tracking at +4% ahead of schedule.', status: 'Archived' },
];

const Stakeholders = () => {
  return (
    <div className="max-w-5xl mx-auto space-y-8">
      <div className="flex justify-between items-end">
        <div>
          <h2 className="text-2xl font-bold text-ice">Stakeholder Sync</h2>
          <p className="text-sm text-slate-400 font-mono mt-1">EXECUTIVE COMMS LOG</p>
        </div>
        <button className="bg-rocket-600 hover:bg-rocket-500 text-white px-4 py-2 rounded text-xs font-bold transition-all shadow-lg">
          GENERATE BRIEFING
        </button>
      </div>

      <div className="grid gap-4">
        {updates.map(update => (
          <div key={update.id} className="glass-panel p-6 rounded-2xl border border-slate-800 hover:border-slate-700 transition-all">
            <div className="flex justify-between items-start mb-4">
              <div className="flex items-center space-x-3">
                <div className="w-8 h-8 rounded-full bg-slate-800 flex items-center justify-center border border-slate-700">
                  <SafeIcon name="User" size={14} />
                </div>
                <div>
                  <h4 className="text-sm font-bold text-ice">{update.author}</h4>
                  <p className="text-[10px] font-mono text-slate-500">{update.date}</p>
                </div>
              </div>
              <span className={`text-[10px] font-mono px-2 py-0.5 rounded border ${
                update.type === 'Risk Alert' ? 'bg-red-500/10 text-red-400 border-red-500/30' : 'bg-slate-800 text-slate-400 border-slate-700'
              }`}>
                {update.type}
              </span>
            </div>
            <p className="text-sm text-slate-300 leading-relaxed italic">"{update.content}"</p>
            <div className="mt-4 pt-4 border-t border-slate-800 flex justify-between items-center text-[10px] font-mono text-slate-600">
              <div className="flex items-center">
                <SafeIcon name="Check" className="mr-1 text-green-500" /> RECIPIENTS: CEO, CTO, BOARD
              </div>
              <div className="flex items-center space-x-4">
                <button className="hover:text-rocket-400">View Analytics</button>
                <button className="hover:text-ice">Forward</button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Stakeholders;